import React, { type FC, type PropsWithChildren, useState } from 'react'
import { isHydrated } from 'utils/hydration'

import { type Plan } from '@/types/graphql'

type Cart = {
  plan?: Plan
  licencesCountValue?: number
}
type CartContextType = {
  cart: Cart | null
  actions: {
    setCart: (cart: Cart | null) => void
  }
}

const CartContext = React.createContext<CartContextType>({
  cart: null,
  actions: {
    setCart: () => {},
  },
})

const CartProvider: FC<PropsWithChildren> = ({ children }) => {
  const savedCart = isHydrated() ? localStorage.getItem('cart') : null
  const defaultCart = savedCart !== null ? JSON.parse(savedCart) : null
  const [cart, setCart] = useState(defaultCart)

  const handleCartUpdate = (updatedCart: Cart | null) => {
    localStorage.setItem('cart', JSON.stringify(updatedCart))
    setCart(updatedCart)
  }

  return (
    <CartContext.Provider
      value={ {
        cart,
        actions: { setCart: handleCartUpdate },
      } }

    >
      {children}
    </CartContext.Provider>
  )
}

export default CartProvider
export { CartContext }
